"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("./base.service");
var api_constants_1 = require("../constants/api.constants");
var models_1 = require("../models");
var serializers_1 = require("./serializers");
var AssessmentService = /** @class */ (function (_super) {
    __extends(AssessmentService, _super);
    function AssessmentService(options, assessmentClient, assessmentSerializer) {
        var _this = _super.call(this, options) || this;
        _this.assessmentClient = assessmentClient;
        _this.assessmentSerializer = assessmentSerializer;
        return _this;
    }
    AssessmentService.newInstance = function (options) {
        var optionSerializer = new serializers_1.OptionsSerializer(new serializers_1.PlayerOptionsSerializer(), new serializers_1.ScoreOptionsSerializer(), new serializers_1.ReportingOptionsSerializer(new serializers_1.SettingsPerformanceBandSerializer()), new serializers_1.AssessmentTypeOptionsSerializer(), new serializers_1.StandardsOptionsSerializer(new serializers_1.StandardSetSerializer()));
        return new AssessmentService(options, insync_assess_sdk_1.AssessmentClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), new serializers_1.AssessmentSerializer(new serializers_1.AssessmentTemplateSerializer(), optionSerializer));
    };
    /**
     * Find all assessments by owner
     *
     * @param {string} ownerId                  - Assessment owner id
     * @param filters
     * @param limit
     * @param skip
     * @returns {Promise<Assessment[]>}
     *
     * @example
     * findByOwner('my-id',['status1', 'status2'], ['key,asc', 'otherKey,desc'], {limit: 20, skip: 10})
     */
    AssessmentService.prototype.findByOwner = function (ownerId_1, filters_1) {
        return __awaiter(this, arguments, void 0, function (ownerId, filters, limit, skip, curriculumId) {
            var pageable;
            var _this = this;
            if (limit === void 0) { limit = 100; }
            if (skip === void 0) { skip = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.findByOwner(ownerId, filters, { limit: limit, skip: skip }, this.getDefaultHeaders({
                            curriculumId: filters.curriculum ? filters.curriculum[0] : curriculumId,
                        }))];
                    case 1:
                        pageable = _a.sent();
                        return [2 /*return*/, pageable.data.map(function (item) { return _this.assessmentSerializer.serialize(item); })];
                }
            });
        });
    };
    /**
     * Find all assessments by currently logged user
     *
     * @param filters
     * @param limit
     * @param skip
     * @returns {Promise<Assessment[]>}
     *
     * @example
     * findByCurrentUser(['status1', 'status2'], ['key,asc', 'otherKey,desc'], {limit: 20, skip: 10})
     */
    AssessmentService.prototype.findByCurrentUser = function (filters_1) {
        return __awaiter(this, arguments, void 0, function (filters, limit, skip, curriculumId) {
            var pageable;
            var _this = this;
            if (limit === void 0) { limit = 200; }
            if (skip === void 0) { skip = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.findByUser(filters, { limit: limit, skip: skip }, this.getDefaultHeaders({
                            curriculumId: filters.curriculum ? filters.curriculum[0] : curriculumId,
                        }))];
                    case 1:
                        pageable = _a.sent();
                        return [2 /*return*/, pageable.map(function (dto) { return _this.assessmentSerializer.serialize(dto); })];
                }
            });
        });
    };
    /**
     * Assign an assessment
     * @param {string}        assessmentTemplateId    - Assessment template Id
     * @param {Assignment[]}  assignments             - Assignments
     */
    AssessmentService.prototype.assign = function (assessmentTemplateId, assignments, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.assign(assessmentTemplateId, assignments, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Mark the assessment and its attempts as Open
     * @param {string} assessmentId - unique identifier for the assessment
     */
    AssessmentService.prototype.open = function (assessmentId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.open(assessmentId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Finish an assessment
     * @param {string} assessmentId - unique identifier for the assessment id
     */
    AssessmentService.prototype.finish = function (assessmentId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.finish(assessmentId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Find the assessment by id
     * @param {string} assessmentId - unique identifier for the assessment
     * @returns {Assessment}
     */
    AssessmentService.prototype.findOne = function (assessmentId, assigneeId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.findOneById(assessmentId, assigneeId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.assessmentSerializer.serialize(data)];
                }
            });
        });
    };
    /**
     * Reassign an assessment
     * @param {string}      assessmentId
     * @param {Assignment}  assignment   - group up all the needed params to create a reassign.
     */
    AssessmentService.prototype.reassign = function (assessmentId, assignment, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.reassign({
                            assessmentId: assessmentId,
                            startDate: assignment.startDate,
                            endDate: assignment.endDate,
                            assigneeIds: assignment.assigneeIds,
                            autoLaunch: assignment.autoLaunch,
                            settings: assignment.settings,
                        }, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Stop the assessment
     * @param {string} assessmentId - unique identifier for the assessment
     */
    AssessmentService.prototype.stop = function (assessmentId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.stop(assessmentId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Merge classes into the Assessment
     * @param {string} assessments - Assessment template
     * @param {string} classes     - Class template array
     */
    AssessmentService.prototype.mergeClasses = function (assessments, classes) {
        if (assessments === void 0) { assessments = []; }
        if (classes === void 0) { classes = []; }
        return assessments.map(function (assessment) {
            return new models_1.Assessment(__assign(__assign({}, assessment), { assessmentClass: classes.find(function (_a) {
                    var id = _a.id;
                    return id === assessment.assessmentClass.id;
                }) ||
                    assessment.assessmentClass }));
        });
    };
    /**
     * Delete an assessment
     * @param {string}      assessmentId
     */
    AssessmentService.prototype.delete = function (assessmentId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentClient.delete(assessmentId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Mark the assessment and its attempts as Open
     * @param {string} assessmentId - unique identifier for the assessment
     */
    AssessmentService.prototype.reopen = function (assessmentId, endDate, assigneeIds, curriculumId, startDate) {
        return __awaiter(this, void 0, void 0, function () {
            var reopenPayload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reopenPayload = {
                            assessmentId: assessmentId,
                            endDate: endDate,
                            assigneeIds: assigneeIds,
                            startDate: startDate
                        };
                        return [4 /*yield*/, this.assessmentClient.reopen(reopenPayload, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return AssessmentService;
}(base_service_1.BaseService));
exports.AssessmentService = AssessmentService;
